import { InitialState } from "../slices/models";

export const dataKitColetaReducer = (state: InitialState, action) => {
  state.dataKitColeta.data = action.payload?.listaKitColeta || [];
  state.dataKitColeta.isLoading = false;
  state.dataKitColeta.pagination = {
    page: action.meta.arg?.pagina,
    rowsPerPage: action.meta.arg?.itensPorPagina,
    totalPages: action.payload.totalPaginas,
    totalItems: action.payload.totalRegistros,
  };
  state.dataKitColeta.requestGetParams = {
    ...action.meta.arg,
    diretorios: action.payload?.listaDiretorios || [],
  };
};

export default dataKitColetaReducer;
